/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: LobbyBackgroundGutter.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  09.06.23 1:50 pm.
 * Last modified: 09.06.23 1:50 pm.
 *
 * More information at: https://egt-digital.com/
 */

import React from 'react';
import { useSettings } from '../contexts/SettingsContext';

const LobbyBackgroundGutter = () => {
    const [{ openType }] = useSettings();

    return (
        <div
            className={`egtd-lobby-background-gutter egtd-lobby-background-gutter-${
                openType === 'fullscreen' ? 'fullscreen' : 'ingame'
            }`}
        />
    );
};

export default LobbyBackgroundGutter;
